/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
import { Fragment, useState } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, SelectControl, RangeControl  } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import Slider from "react-slick";
import './../../assets/slick/slick.css';
import './../../assets/slick/slick-theme.css';

import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	
	const { getCurrentPostId } = wp.data.select("core/editor");
	const post_id = getCurrentPostId();

	// const [tripGallery, setTripGallery] = useState([]);

	// if( post_id != null ){
	// 	useSelect( () => {
	// 		fetch( _wp_travel.site_url + '/wp-json/wp-travel-block/v1/get-trip-gallery?id=' + post_id, {
	// 			method: "GET"
	// 		  }).then((res) => res.json())
	// 			.then((data) => setTripGallery( data ) )
	// 			.catch((err) => console.error(err));
	// 	}, [] );
	// }
	

	const { attributes, setAttributes } = props;
	const { galleryDesign, sliderHeight, tripsToShow, sliderAutoplay, sliderDots, sliderArrow  } = attributes;

	const settings = {
		dots: sliderDots,
		arrows: sliderArrow,
		autoplay: sliderAutoplay,
		infinite: true,
		speed: 500,
		slidesToShow: tripsToShow,
		slidesToScroll: 1,
	};

	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					<PanelBody title={ __( 'Trip Gallery Options', 'wp-travel-blocks' ) } >
						<SelectControl
							label={ __( 'Gallery Type', 'wp-travel-blocks' ) }
							value={ galleryDesign }
							options={ [
								{ label: 'Slider', value: 'slider' },
								{ label: 'Grid', value: 'gridStyle' },
							] }
							onChange={ ( value ) => setAttributes( { galleryDesign: value } ) }
						/>
						{
							galleryDesign === 'slider' &&
							<>
								<RangeControl
									label={ __('Slider Height', 'wp-travel-blocks') }
									value={ sliderHeight }
									onChange={ ( value ) => setAttributes( { sliderHeight: value } ) }
									min={ 20 }
									max={ 1000 }
								/>
								<RangeControl
									label={ __('Slide to Show', 'wp-travel-blocks') }
									value={ tripsToShow }
									onChange={ ( value ) => setAttributes( { tripsToShow: value } ) }
									min={ 1 }
									max={ 5 }
								/>
								<ToggleControl
									label={ __( 'Auto slide', 'wp-travel-blocks' ) }
									checked={ sliderAutoplay }
									onChange={ () => setAttributes( { sliderAutoplay: ! sliderAutoplay } ) }
								/>
								<ToggleControl
									label={ __( 'Show Dots', 'wp-travel-blocks' ) }
									checked={ sliderDots }
									onChange={ () => setAttributes( { sliderDots: ! sliderDots } ) }
								/>
								<ToggleControl
									label={ __( 'Show Arrow', 'wp-travel-blocks' ) }
									checked={ sliderArrow }
									onChange={ () => setAttributes( { sliderArrow: ! sliderArrow } ) }
								/>
							</>
						}
						
					</PanelBody>
				</InspectorControls>
			</Fragment>
			{
				galleryDesign === 'slider' &&
				<div className='wptravel-block-trip-gallery'>
					<Slider 
						className='wp-travel-advanced-gallery-items-list'
						style={
							{height: sliderHeight+"px"}
						}
						{...settings}
					>
					
						<div>
							<span className='wptag__thumbnail'>
								<img 
									src={placeHolderImage} 
									style={
										{height: sliderHeight+"px"}
									}
								/>
							</span>
							
						</div>

						<div>
							<span className='wptag__thumbnail'>
								<img 
									src={placeHolderImage} 
									style={
										{height: sliderHeight+"px"}
									}
								/>
							</span>
							
						</div>

						<div>
							<span className='wptag__thumbnail'>
								<img 
									src={placeHolderImage} 
									style={
										{height: sliderHeight+"px"}
									}
								/>
							</span>
							
						</div>
					
					</Slider>
				</div>
				||
				<ServerSideRender
					block="wp-travel-blocks/trip-gallery"
					attributes={ props.attributes }
				/>
			}
		</div>
	);
}
